<header class="page-head" data-testid="statistics-head">
  <div class="page-head__identity">
    <span class="page-head__icon"><i class="fa fa-bar-chart"></i></span>
    <div>
      <h1 class="page-head__title" data-testid="statistics-title">{{ title }}</h1>
      <p class="page-head__subtitle" *ngIf="client">{{ client.email }} · conta gerenciada</p>
    </div>
  </div>
  <div class="page-head__actions">
    <a routerLink="/partner" class="sf-btn sf-btn--ghost">
      <i class="fa fa-chevron-left"></i> Voltar
    </a>
    <button type="button" class="sf-btn sf-btn--primary" *ngIf="canAccessClientAccount && client" (click)="simulate()"
      data-testid="btn-access-account">
      <i class="fa fa-external-link"></i> Acessar conta
    </button>
  </div>
</header>

<app-skeleton *ngIf="loadingBlocks.client" variant="card" [count]="3"
  label="Carregando o cliente" data-testid="client-loading"></app-skeleton>

<div class="sf-card empty" *ngIf="blockErrors.client" data-testid="client-error">
  <i class="fa fa-exclamation-triangle"></i>
  <p><strong>Não foi possível abrir esta conta</strong></p>
  <p class="field-hint">Tente de novo em instantes. Se continuar, fale com o suporte.</p>
  <button type="button" class="sf-btn sf-btn--primary sf-btn--sm" (click)="retryClient()">
    <i class="fa fa-refresh"></i> Tentar de novo
  </button>
</div>

<ng-container *ngIf="client">
  <div class="block-label">
    <i class="fa fa-wallet"></i> <strong>Saldo agora</strong> <span>não depende do período</span>
  </div>

  <app-skeleton *ngIf="loadingBlocks.credits" variant="card" [count]="3"
    label="Carregando o saldo" data-testid="balance-loading"></app-skeleton>

  <div class="alert alert-warning" *ngIf="blockErrors.credits" data-testid="balance-error">
    <i class="fa fa-exclamation-triangle"></i>
    <div class="grow">
      <strong>Não foi possível carregar o saldo agora.</strong> Não é saldo zero — tente de novo em instantes.
    </div>
    <button type="button" class="sf-btn sf-btn--secondary sf-btn--sm" (click)="loadCredits()" data-testid="btn-retry-balance">
      <i class="fa fa-refresh"></i> Tentar de novo
    </button>
  </div>

  <div class="balance-top" *ngIf="credits$ | async as topCredits" data-testid="balance-top">
    <app-account-balance [source]="topCredits" mode="block"></app-account-balance>
  </div>

  <form class="sf-card" (submit)="filterChanged()" data-testid="period-card">
    <div class="section-title"><i class="fa fa-calendar"></i> Período</div>
    <div class="period-bar">
      <div class="field">
        <label for="startDate">Data inicial</label>
        <input type="date" id="startDate" name="startDate" class="form-control"
          [ngModel]="toInputDate(startDate)" (ngModelChange)="startDateChanged($event)" data-testid="input-start-date" />
      </div>
      <div class="field">
        <label for="endDate">Data final</label>
        <input type="date" id="endDate" name="endDate" class="form-control"
          [ngModel]="toInputDate(endDate)" (ngModelChange)="endDateChanged($event)" data-testid="input-end-date" />
      </div>
      <div class="period-shortcuts">
        <button type="button" class="chip" [class.on]="activePeriod === 7" (click)="setPeriod(7)">7 dias</button>
        <button type="button" class="chip" [class.on]="activePeriod === 30" (click)="setPeriod(30)">30 dias</button>
        <button type="button" class="chip" [class.on]="activePeriod === 90" (click)="setPeriod(90)">90 dias</button>
      </div>
      <button class="sf-btn sf-btn--primary search-btn" type="submit" [disabled]="is90DayInterval || invalidPeriod"
        data-testid="btn-search-period">
        <i class="fa fa-search"></i> Pesquisar
      </button>
    </div>
    <p class="field-error" *ngIf="invalidPeriod">Período inválido: a data inicial é depois da final.</p>
    <p class="field-error" *ngIf="is90DayInterval">Você precisa selecionar o período de no máximo <b>90 dias</b>.</p>
    <p class="field-hint" *ngIf="!filterStarted">Selecione a data inicial e a data final para pesquisar.</p>
  </form>

  <div class="alert alert-warning" *ngIf="blockErrors.messages || blockErrors.clicks || blockErrors.recharges"
    data-testid="period-error">
    <i class="fa fa-exclamation-triangle"></i>
    <div class="grow">
      <strong>Não foi possível carregar parte das estatísticas do período.</strong> Tente de novo em instantes.
    </div>
    <button type="button" class="sf-btn sf-btn--secondary sf-btn--sm" (click)="filterChanged()">
      <i class="fa fa-refresh"></i> Tentar de novo
    </button>
  </div>

  <app-skeleton *ngIf="loadingBlocks.messages" variant="card" [count]="3"
    label="Carregando as mensagens do cliente" data-testid="messages-loading"></app-skeleton>

  <div class="kpis" *ngIf="messages$ | async as messages" data-testid="messages-kpis">
    <div class="kpi">
      <h4>Mensagens enviadas</h4>
      <small><i class="fa fa-commenting-o ic"></i> SMS enviados</small>
      <b>{{ messages.sms | numberFormat }}</b>
    </div>
    <div class="kpi">
      <h4>Mensagens enviadas</h4>
      <small><i class="fa fa-bolt ic"></i> Cliques</small>
      <b>{{ messages.clicks | numberFormat }}</b>
    </div>
    <div class="kpi" *ngIf="rechargesTotal !== null">
      <h4>Recargas no período</h4>
      <small><i class="fa fa-money ic"></i> Total confirmado</small>
      <b>{{ rechargesTotal | numberFormat : 'R$ ' : true : 2 }}</b>
    </div>
  </div>

  <app-skeleton *ngIf="loadingBlocks.clicks" variant="table-row" [count]="5" [columns]="4"
    label="Carregando os cliques por automação" data-testid="clicks-loading"></app-skeleton>

  <div class="clicks-grid" *ngIf="clicks$ | async as clicks">
    <div class="sf-card">
      <div class="section-title"><i class="fa fa-bolt"></i> Cliques por automação</div>
      <table class="table">
        <thead>
          <tr><th>Automação</th><th class="text-end">SMS enviados</th><th class="text-end">Cliques</th></tr>
        </thead>
        <tbody>
          <tr *ngFor="let campaign of clicks.campaigns">
            <td><strong>{{ campaign.name }}</strong></td>
            <td class="text-end">{{ campaign.sms | numberFormat }}</td>
            <td class="text-end">{{ campaign.clicks | numberFormat }}</td>
          </tr>
          <tr *ngIf="!clicks.campaigns?.length">
            <td colspan="3" class="muted">Nenhum envio de automação no período.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="sf-card">
      <div class="section-title"><i class="fa fa-paper-plane"></i> Cliques por SMS Massivo</div>
      <table class="table">
        <thead>
          <tr><th>SMS Massivo</th><th class="text-end">SMS enviados</th><th class="text-end">Cliques</th></tr>
        </thead>
        <tbody>
          <tr *ngFor="let campaign of clicks.broadcasts">
            <td><strong>{{ campaign.name }}</strong></td>
            <td class="text-end">{{ campaign.sms | numberFormat }}</td>
            <td class="text-end">{{ campaign.clicks | numberFormat }}</td>
          </tr>
          <tr *ngIf="!clicks.broadcasts?.length">
            <td colspan="3" class="muted">Nenhum SMS Massivo no período.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <app-skeleton *ngIf="loadingBlocks.recharges" variant="table-row" [count]="5" [columns]="4"
    label="Carregando as recargas do cliente" data-testid="recharges-loading"></app-skeleton>

  <div class="sf-card" *ngIf="recharges$ | async as recharges" data-testid="recharges-card">
    <div class="section-title"><i class="fa fa-money"></i> Recargas</div>
    <table class="table">
      <thead>
        <tr>
          <th>Data</th>
          <th>Serviço</th>
          <th class="text-end">Créditos</th>
          <th class="text-end">Valor unitário</th>
          <th class="text-end">Valor total</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let recharge of recharges" data-testid="recharge-row">
          <td>{{ recharge.created_at | date: 'dd/MM/yyyy HH:mm' }}</td>
          <!-- Recarga por valor (carteira) grava `credits: 0` em `user_recharges` (PartnerService::getRecharges,
               não alterado — alimenta a API externa). Aqui é só leitura: 0 créditos não é "SMS sem créditos",
               é recarga de carteira, então o rótulo e as colunas numéricas mudam (decisão do mockup, 27/10). -->
          <td>{{ recharge.credits === 0 ? 'Carteira' : recharge.service }}</td>
          <td class="text-end">{{ recharge.credits === 0 ? '—' : (recharge.credits | numberFormat) }}</td>
          <td class="text-end">{{ recharge.credits === 0 ? '—' : (recharge.price | numberFormat: 'R$ ':true:3) }}</td>
          <td class="text-end"><strong>{{ recharge.total | numberFormat: 'R$ ':true:2 }}</strong></td>
        </tr>
        <tr *ngIf="!recharges.length">
          <td colspan="5" class="muted">Nenhuma recarga no período.</td>
        </tr>
      </tbody>
    </table>
    <p class="field-hint table-note" *ngIf="hasWalletRecharge(recharges)">
      Linha com Créditos "—": recarga em R$ da carteira (sem pacote de créditos).
    </p>
  </div>

  <app-skeleton *ngIf="loadingBlocks.blacklist" variant="table-row" [count]="6" [columns]="4"
    label="Carregando a blacklist do cliente" data-testid="blacklist-loading"></app-skeleton>

  <div class="alert alert-warning" *ngIf="blockErrors.blacklist" data-testid="blacklist-error">
    <i class="fa fa-exclamation-triangle"></i>
    <div class="grow"><strong>Não foi possível carregar a blacklist agora.</strong></div>
    <button type="button" class="sf-btn sf-btn--secondary sf-btn--sm" (click)="pageChanged(1)">
      <i class="fa fa-refresh"></i> Tentar de novo
    </button>
  </div>

  <div class="sf-card" *ngIf="blacklistPhones$ | async as blacklist" data-testid="blacklist-card">
    <div class="section-title section-title--bar">
      <span><i class="fa fa-ban"></i> Blacklist</span>
      <button type="button" class="sf-btn sf-btn--primary sf-btn--sm" (click)="showAddPhonesModal(blacklistModal)">
        <i class="fa fa-sliders"></i> Gerenciar blacklist
      </button>
    </div>
    <div class="search-wrap blacklist-search">
      <i class="fa fa-search"></i>
      <input type="text" name="phonesFilter" class="form-control" placeholder="Digite o número e tecle ENTER"
        [(ngModel)]="phonesFilter" (keyup)="filterKeyPress($event)" data-testid="input-blacklist-search" />
      <button type="button" class="search-go" aria-label="Pesquisar" (click)="pageChanged(1)">
        <i class="fa fa-search"></i>
      </button>
    </div>
    <table class="table">
      <thead>
        <tr>
          <th>Telefone</th>
          <th class="date-col">Data inclusão</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let phone of blacklist.data">
          <td><strong>{{ phone.phone }}</strong></td>
          <td>{{ phone.created_at | date:'dd/MM/yyyy HH:mm' }}</td>
        </tr>
        <tr *ngIf="!blacklist.data?.length">
          <td colspan="2" class="muted">Nenhum número na blacklist.</td>
        </tr>
      </tbody>
    </table>
    <app-pagination
      look="v2"
      [currentPage]="blacklist.current_page"
      [itemsPerPage]="blacklist.per_page"
      [totalItems]="blacklist.total"
      (pageChanged)="pageChanged($event)"
    ></app-pagination>
  </div>
</ng-container>

<ng-template #blacklistModal let-blacklistModal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">
      <i class="fa fa-ban"></i> Gerenciar blacklist
      <span class="sub">{{ client?.name }}</span>
    </h4>
    <button type="button" class="sf-btn sf-btn--ghost sf-btn--icon sf-btn--sm" aria-label="Fechar" (click)="blacklistModal.dismiss('Cross click')">
      <i class="fa fa-times"></i>
    </button>
  </div>

  <div class="modal-body">
    <div class="field">
      <label for="blacklistPhones">Números *</label>
      <textarea id="blacklistPhones" class="form-control" [(ngModel)]="phones" rows="10" placeholder="Cole aqui os números um abaixo do outro ou separados por vírgulas.

Exemplo:
14999999999
11999999999
-ou-
14999999999, 11999999999"></textarea>
      <span class="field-hint">Um número por linha ou separados por vírgula. "Adicionar" coloca na blacklist; "Remover" tira.</span>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="sf-btn sf-btn--ghost push" (click)="blacklistModal.dismiss()">Fechar</button>
    <button type="button" class="sf-btn sf-btn--secondary" (click)="delPhones(blacklistModal)" [disabled]="!phones">
      <i class="fa fa-minus"></i> Remover
    </button>
    <button type="button" class="sf-btn sf-btn--primary" (click)="addPhones(blacklistModal)" [disabled]="!phones">
      <i class="fa fa-plus"></i> Adicionar
    </button>
  </div>
</ng-template>
